<template>
    <div
        ref="collapse-container"
        :class="[
            'collapse-container',
            pageLang,
            {
                pc: isPc
            }
        ]"
    >
        <div class="collapse-panel" :style="[cssPropertys]">
            <section
                :class="[
                    'panel-body',
                    {
                        'full-height': !isCollapsed
                    }
                ]"
            >
                <free-container :children="tpl.children"></free-container>
            </section>
            <button :class="['collapse-btn', btnPosition]" @click="toggleCollapse">
                <p v-if="showText" class="collapse-text" v-html="btnText"></p>
                <Icon class="collapse-icon" :isActive="!isCollapsed" :iconColor="iconColor"></Icon>
            </button>
        </div>
    </div>
</template>
<script>
import Icon from './icon.vue';
import { isEditor, isPc, getPageLang } from '../fego/utils';
import { FOLD_TYPE, BTN_POSITION } from '../common/constants.js';
const { plugins } = window.FEGOEditor || window.FEGORender;
const { ComplexComp } = plugins || {};
const {
    rem: { rem }
} = window.FEGOBridge;
export default {
    name: 'collapse-container',
    components: {
        Icon,
        FreeContainer: ComplexComp && ComplexComp.Container.Free
    },
    props: {
        tpl: Object,
        text: String,
        collapseType: String,
        expandText: String,
        collapseText: String,
        iconColor: String,
        textColor: String,
        showBorderRadius: Number,
        showScale: Number,
        defaultCollapsed: Boolean,
        btnPosition: {
            type: String,
            default: BTN_POSITION.BOTTOM
        }
    },
    data() {
        return {
            isSupport: !!ComplexComp,
            isPc: isPc(),
            isEditor: isEditor(),
            pageLang: getPageLang(),
            isCollapsed: !!this.defaultCollapsed // 默认折叠
        };
    },
    computed: {
        showText() {
            return this.collapseType === FOLD_TYPE.TEXT_ARROW && this.btnText;
        },
        bottomSpace() {
            return this.btnPosition === BTN_POSITION.RIGHT ? 0 : 40;
        },
        cssPropertys() {
            const containerHeight = this.tpl.style.height; // 容器高度
            const bodyFullHeight = containerHeight - this.bottomSpace; // 内容最大高度
            const bodyHeight = bodyFullHeight * (this.showScale / 100); // 当前内容高度
            return {
                '--panel-body-border-radius': rem.str(this.showBorderRadius),
                '--panel-body-full-height': rem.str(bodyFullHeight),
                '--panel-body-height': rem.str(bodyHeight),
                '--panel-padding-bottom': rem.str(this.bottomSpace),
                '--collapse-text-color': this.textColor
            };
        },
        btnText() {
            return this.isCollapsed ? this.expandText : this.collapseText;
        }
    },
    methods: {
        toggleCollapse() {
            this.isCollapsed = !this.isCollapsed;
        }
    },
    mounted() {}
};
</script>
<style lang="less" scoped>
@import './index.less';
.collapse-container {
    height: auto !important;
}
</style>
